module.exports = __webpack_public_path__ + "static/media/info-btn-5.dac30389.jpg";